// TODO RENAME THIS COMPONENT
import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {MULTI_UNIT_RESULT_COUNT} from '../utils/edap';
import {MultiUnitItem} from '../MultiUnitItem/MultiUnitItem';
import './MultiUnitListing.less';

const checkForNullFields = (list, field) => {
    return list.hasOwnProperty(field) && list[field] === null;
};

export default class MultiUnitListing extends Component {
    static contextType = TrackingContext;

    render() {
        const {
            context,
            isDatelessSearch,
            isMetric,
            multiUnitList,
            propertyId,
            clientLogger
        } = this.props;
        const areListingsAvailable =
            multiUnitList &&
            multiUnitList.multiUnitSearch &&
            multiUnitList.multiUnitSearch.listings &&
            multiUnitList.multiUnitSearch.listings.length > 0;
        if (areListingsAvailable) {
            this.context.trigger(MULTI_UNIT_RESULT_COUNT, {
                propertyId,
                resultCount: multiUnitList.multiUnitSearch.listings.length
            });

            multiUnitList.multiUnitSearch.listings.map((list) => {
                Object.keys(list).forEach((property) => {
                    if (checkForNullFields(list, property)) {
                        clientLogger.captureMessage(
                            `[MultiUnitSearchQuery warning]: Received null value for field - ${property} and Listing Id -  ${list.listingId}`
                        );
                    }
                });
                if (checkForNullFields(list, 'priceSummary')) {
                    clientLogger.captureException(
                        `[MultiUnitSearchQuery price error]: Received null value for price fields for Listing Id - ${list.listingId}`
                    );
                }
            });
        }
        return (
            (areListingsAvailable &&
                multiUnitList.multiUnitSearch.listings.map((list) => (
                    <MultiUnitItem
                        {...list} // watch out! `list` is type `any` so spreading it here means this component's props can't be type-checked!
                        context={context}
                        isDatelessSearch={isDatelessSearch}
                        isMetric={isMetric}
                        key={list.listingId}
                    />
                ))) || (
                <div className="MultiUnit__ErrorMessage">
                    <FormattedMessage id="tempOopsMessage" />
                </div>
            )
        );
    }
}
